<script>
import api from '@/command/api'
import FormView from '../../../components/FormView'
import apiTool from '@/command/apiTool'
import { operatingCycle } from '@/utils/textFile'
import { getAction } from '@/command/netTool'
import moment from 'moment'

export default {
  props: {
    dataForm: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cascaderList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      ...api.command.getState(),
      day_before_rule: [],
      day_later_rule: [],
      pickupTimeRangeList: [],
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.generateDateTiems(false)
    getAction('/admin/dict/codes?codes=day_before_rule,day_later_rule', {}, '/bpi').then((e) => {
      this.day_before_rule = (e.data['day_before_rule'] || []).map((e) => ({
        name: e.name,
        value: e.id,
      }))
      this.day_later_rule = (e.data['day_later_rule'] || []).map((e) => ({
        name: e.name,
        value: e.id,
      }))
    })
  },
  methods: {
    generateDateTiems(reset = true) {
      console.log('重新计算时间区间')
      this.pickupTimeRangeList = []
      if (reset) {
        this.dataForm.pickupTimeRange = []
      }
      const point = this.dataForm
      // 默认0:00-24:00
      let openTime = 0
      let closeTime = 24
      // 处理开始时间和结束时间的分钟部分
      if (point.openTime) {
        const [openHour, openMinute] = moment(point.openTime).format('HH:mm').split(':').map(Number)

        // 开始时间向上取整（如果有分钟则+1小时）
        openTime = openMinute > 0 ? openHour + 1 : openHour
      }
      if (point.closeTime) {
        const [closeHour, closeMinute] = moment(point.closeTime).format('HH:mm').split(':').map(Number)

        // 结束时间向下取整（如果有分钟则保持原小时，23:59特殊处理）
        closeTime = closeHour === 23 && closeMinute === 59 ? 24 : closeHour
      }
      // 计算时间段数量 默认全天
      let timeStep = point.pickupCycleSection || closeTime - openTime
      const totalHours = closeTime - openTime
      // 计算完整时间段数量和剩余时间
      const fullSlots = Math.floor(totalHours / timeStep)
      const remainder = totalHours % timeStep
      const hasRemainder = remainder > 0

      // 处理结束时间为24点的情况
      const formatTime = (hour) => {
        if (hour === 24) return '23:59'
        return `${String(hour).padStart(2, '0')}:00`
      }
      // 生成时间段数组
      const timeSlots = Array.from({ length: fullSlots }, (_, i) => {
        const start = openTime + i * timeStep
        const end = start + timeStep
        return {
          name: `${formatTime(start)}-${formatTime(end)}`,
          value: `${formatTime(start)}-${formatTime(end)}`,
          startHour: formatTime(start),
          endHour: formatTime(end),
        }
      })

      // 处理剩余时间
      if (hasRemainder) {
        const lastStart = openTime + fullSlots * timeStep
        timeSlots.push({
          name: `${formatTime(lastStart)}-${formatTime(closeTime)}`,
          value: `${formatTime(lastStart)}-${formatTime(closeTime)}`,
          startHour: formatTime(lastStart),
          endHour: formatTime(closeTime),
        })
      }

      this.pickupTimeRangeList = [
        {
          name: '全选',
          value: '-1',
          type: 'all',
        },
        ...timeSlots,
      ]
    },
    getFilterData() {
      return operatingCycle.filter((e) => this.dataForm.businessCycle.indexOf(e.value) !== -1)
    },
    getSumbitData() {
      const codeText = ['province', 'city', 'area']
      let arr = document.getElementsByClassName('ant-cascader-picker-label')[0].innerHTML.split('/')
      const obj = {}
      arr.forEach((e, i) => {
        obj[codeText[i] + 'Name'] = e
        obj[codeText[i] + 'Code'] = this.dataForm.regionCode[i]
      })
      return obj
    },
    sumbit() {
      if (!this.dataForm.name) {
        this.$message.warning('请输入自提点名称！')
        return
      }
      if (!this.dataForm.jwd) {
        this.$message.warning('请选择自提点位置！')
        return
      }
      if (!this.dataForm.regionCode || this.dataForm.regionCode.length === 0) {
        this.$message.warning('请选择自提点地址！')
        return
      }
      if (!this.dataForm.linkPhone) {
        this.$message.warning('请输入联系方式！')
        return
      }
      if (
        !this.dataForm.dayBefore ||
        !this.dataForm.dayBeforeRuleCode ||
        !this.dataForm.dayLater ||
        !this.dataForm.dayLaterRuleCode
      ) {
        this.$message.warning('请完善自提时间设置！')
        return
      }

      if (!this.dataForm.pickupTimeRange || this.dataForm.pickupTimeRange.length === 0) {
        this.$message.warning('请选择提货时间区间！')
        return
      }

      const codeData = this.getSumbitData()
      let lxfs = /^((0\d{2,3}-?\d{7,8})|(1[3465789]\d{9}))$/
      if (!lxfs.test(this.dataForm.linkPhone)) {
        this.$message.warning('请正确输入联系方式！')
        return
      }
      // 获取筛选数据
      let filterData = this.getFilterData()
      let obj = {
        ...this.dataForm,
        ...codeData,
        businessCycleName: filterData.map((e) => e.name).toString(),
      }

      this.$emit('success', obj)
    },
    returnForm1() {
      const formData = [
        {
          name: '自提点名称',
          key: 'name',
          type: 'input',
          cols: 22,
          rules: [
            {
              required: true,
              type: 'string',
            },
          ],
        },
        {
          name: '位置 （例：120.184349，30.254460）',
          type: 'row',
          cols: 22,
          gutter: 5,
          rules: [
            {
              required: true,
            },
          ],
          children: [
            {
              type: 'input',
              cols: 20,
              key: 'jwd',
              label: '地址',
              placeholder: '请输入经纬度以中文逗号隔开',
              rules: [
                {
                  required: true,
                  type: 'string',
                },
              ],
            },
            {
              type: 'buttonRight',
              label: '定位',
              cols: 5,
              style: {
                width: '105px',
                marginLeft: ' -5px',
                borderRadius: ' 4px',
                backgroundColor: 'rgba(44, 140, 240, 1)',
              },
              props: {
                type: 'primary',
                icon: 'environment',
              },
              onClick: () => {
                apiTool.openMap({
                  title: '打开地图',
                  value: [],
                  onSuccess: (data) => {
                    this.dataForm.jwd = `${data.lng + '，' + data.lat}`
                    this.dataForm.longitude = data.lng
                    this.dataForm.latitude = data.lat
                    getAction('/api/gao', {
                      location: `${data.lng},${data.lat}`,
                    }).then((res) => {
                      let { address, codes } = res.data
                      this.dataForm.regionCode = codes
                      this.dataForm.address = address
                      this.$forceUpdate()
                    })
                  },
                })
              },
            },
            {
              type: 'cascader',
              cols: 10,
              key: 'regionCode',
              label: '地址',
              typeData: this.cascaderList,
              rules: [
                {
                  required: true,
                  type: 'array',
                },
              ],
            },
            {
              type: 'input',
              cols: 14,
              key: 'address',
              label: '地址',
              rules: [
                {
                  required: true,
                  type: 'string',
                },
              ],
            },
          ],
        },
        {
          name: '联系方式',
          key: 'linkPhone',
          type: 'input',
          cols: 22,
          rules: [
            {
              required: true,
              type: 'string',
            },
          ],
        },
        {
          type: 'timePicker',
          cols: 6,
          key: 'openTime',
          name: '营业开始时间',
          props: {
            format: 'HH:mm',
          },
          onChange: (val) => {
            this.generateDateTiems()
          },
        },
        {
          type: 'timePicker',
          cols: 6,
          key: 'closeTime',
          name: '营业结束时间',
          props: {
            format: 'HH:mm',
          },
          onChange: (val) => {
            this.generateDateTiems()
          },
        },
        {
          type: 'select',
          cols: 9,
          key: 'businessCycle',
          name: '营业周期',
          props: {
            mode: 'multiple',
          },
          typeData: operatingCycle,
        },
        {
          name: '运费(优先级高于商品运费模板)',
          key: 'freightType',
          type: 'radio',
          cols: 22,
          typeData: [
            {
              name: '免运费',
              value: '0',
            },
            {
              name: '按照商品收运费',
              value: '1',
            },
          ],
        },
        {
          display: true,
          name: '自提时间设置',
          type: 'row',
          cols: 22,
          gutter: 6,
          children: [
            {
              type: 'text',
              value: '当日',
              cols: 2,
            },
            {
              type: 'timePicker',
              cols: 6,
              key: 'dayBefore',
              props: {
                format: 'HH:mm',
              },
            },
            {
              type: 'text',
              value: '以前，自提时间',
              cols: 5,
            },
            {
              type: 'select',
              key: 'dayBeforeRuleCode',
              cols: 6,
              placeholder: '请选择',
              typeData: this.day_before_rule,
              onChange: (val) => {
                this.dataForm.dayBeforeRuleName = this.day_before_rule.find((f) => f.value === val)?.name || ''
              },
            },
          ],
          rules: [
            {
              required: true,
            },
          ],
        },
        {
          display: true,
          name: '',
          type: 'row',
          cols: 22,
          gutter: 6,
          children: [
            {
              type: 'text',
              value: '当日',
              cols: 2,
            },
            {
              type: 'timePicker',
              cols: 6,
              key: 'dayLater',
              props: {
                format: 'HH:mm',
              },
            },
            {
              type: 'text',
              value: '以后，自提时间',
              cols: 5,
            },
            {
              type: 'select',
              key: 'dayLaterRuleCode',
              cols: 6,
              typeData: this.day_later_rule,
              placeholder: '请选择',
              onChange: (val) => {
                this.dataForm.dayLaterRuleName = this.day_later_rule.find((f) => f.value === val)?.name || ''
              },
            },
          ],
        },
        {
          name: '提货周期（天）(提货周期时间不能少于自提时间规则，例如：自提时间为T+1，提货周期不能小于2)',
          type: 'inputNumber',
          key: 'pickupCycle',
          cols: 22,
          props: {
            min: 1,
            precision: 0,
          },
        },
        {
          name: '提货时间区间设置（小时）',
          type: 'inputNumber',
          key: 'pickupCycleSection',
          cols: 22,
          props: {
            min: 1,
            precision: 0,
          },
          onChange: (val) => {
            this.generateDateTiems()
          },
        },
        {
          name: '提货时间区间选择',
          type: 'checkBoxButton',
          key: 'pickupTimeRange',
          cols: 24,
          typeData: this.pickupTimeRangeList,
          rules: [
            {
              required: true,
              type: 'array',
            },
          ],
        },
      ]

      return <FormView data={formData} form={this.dataForm} />
    },
  },
  render() {
    return <div>{this.returnForm1()}</div>
  },
}
</script>
<style lang="less" scoped>
/deep/.form-input[data-v-0c5e90f3] {
  margin-top: 4px;
}
/deep/.ant-row-flex.ant-row-flex-start {
  margin-right: -40px !important;
}
</style>
